
import { supabase } from '@/integrations/supabase/client';
import { StructuredIngredient } from '@/types/recipe';
import { withErrorHandling } from '../utils/errorHandling';

/**
 * Service for converting recipe ingredients using OpenAI
 */
export const ingredientConversionService = {
  /**
   * Convert ingredients using OpenAI to get both metric and imperial versions
   */
  convertIngredients: withErrorHandling(
    async (validIngredients: StructuredIngredient[]) => {
      console.log('Converting ingredients with OpenAI:', validIngredients);
      
      const { data, error } = await supabase.functions.invoke('convert-quick-recipe-ingredients', {
        body: { ingredients: validIngredients }
      });

      if (error) {
        console.error('Error calling ingredient conversion function:', error);
        return null;
      }

      console.log('Conversion result:', data);
      return data;
    },
    "Error converting ingredients"
  )
};
